import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import styles from './Engagement.module.css';

export const Engagement: React.FC = () => {
  const { t } = useLanguage();

  return (
    <section className={styles.engagement} id="engagement">
      <div className={styles.engagement__container}>
        <motion.div
          className={styles.engagement__header}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-50px' }}
          transition={{ duration: 0.15 }}
        >
          <span className={styles.engagement__tag}><Sparkles size={14} />{t.engagement.tag}</span>
          <h2 className={styles.engagement__title}>{t.engagement.title}</h2>
          <p className={styles.engagement__subtitle}>{t.engagement.subtitle}</p>
        </motion.div>

        <div className={styles.engagement__grid}>
          <motion.div
            className={styles.engagement__card}
            initial={{ opacity: 0, y: 15 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-50px' }}
            transition={{ duration: 0.15 }}
          >
            <h3 className={styles.engagement__cardTitle}>{t.engagement.title}</h3>
            <ul className={styles.engagement__list}>
              {t.engagement.steps.map((step, idx) => (
                <li key={idx} className={styles.engagement__listItem}>
                  <span className={styles.engagement__dot} />
                  <div>
                    <div className={styles.engagement__listHeading}>{step.title}</div>
                    <div className={styles.engagement__listText}>{step.desc}</div>
                  </div>
                </li>
              ))}
            </ul>
          </motion.div>

          <motion.div
            className={styles.engagement__card}
            initial={{ opacity: 0, y: 15 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-50px' }}
            transition={{ duration: 0.15, delay: 0.05 }}
          >
            <h3 className={styles.engagement__cardTitle}>{t.engagement.tag}</h3>
            <ul className={styles.engagement__list}>
              {t.engagement.personas.map((persona, idx) => (
                <li key={idx} className={styles.engagement__listItem}>
                  <span className={styles.engagement__dot} />
                  <div className={styles.engagement__listText}>{persona}</div>
                </li>
              ))}
            </ul>
          </motion.div>

          <motion.div
            className={styles.engagement__card}
            initial={{ opacity: 0, y: 15 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-50px' }}
            transition={{ duration: 0.15, delay: 0.1 }}
          >
            <h3 className={styles.engagement__cardTitle}>Budget</h3>
            <ul className={styles.engagement__list}>
              {t.engagement.budgets.map((budget, idx) => (
                <li key={idx} className={styles.engagement__listItem}>
                  <span className={styles.engagement__dot} />
                  <div className={styles.engagement__listText}>{budget}</div>
                </li>
              ))}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Engagement;
